// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#resultado-sucesso svg {
  height: 75px;
}

/*animação círculos svgs*/
#resultado-sucesso svg circle {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2.5s ease forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
#resultado-sucesso svg polyline {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 3.5s ease forwards;
  animation-delay: 0.25s;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/email-confirmado/email-confirmado.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,YAAA;AAEJ;;AACA,yBAAA;AAEA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;AACF;;AAEA;EACE;IACE,oBAAA;EACF;AACF;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AAFF","sourcesContent":["#resultado-sucesso svg {\n    height: 75px;\n}\n\n/*animação círculos svgs*/\n\n#resultado-sucesso svg circle {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 2.5s ease forwards;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n\n\n#resultado-sucesso svg polyline {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 3.5s ease forwards;\n  animation-delay: 0.25s;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
